import api from '@services'
import { stripEmptyObjects } from '@utils'
import PersonalInformationService from '../personal-information'

// Base URL for passenger bus microservice (set in .env)
const serviceBaseUrl = process.env.REACT_APP_PASSENGER_BUS_BASE_URL || ''
const servicePrefix = `${serviceBaseUrl}/svc/passenger-bus`
export { s3DocUrl, openS3Doc } from './docUrl'
export { apiErrorMessage } from './apiError'

// Buses CRUD
export const getBuses = async (params) => {
  const response = await api.get(`${servicePrefix}/buses`, { params: stripEmptyObjects(params) })
  return response.data
}

export const getBus = async (id) => {
  const response = await api.get(`${servicePrefix}/buses/${id}`)
  return response.data
}

export const addBus = async (payload) => {
  const response = await api.post(`${servicePrefix}/buses`, payload)
  return response.data
}

export const updateBus = async (payload) => {
  const { id, ...body } = payload
  const response = await api.put(`${servicePrefix}/buses/${id}`, body)
  return response.data
}

export const deleteBus = async (id) => {
  const response = await api.delete(`${servicePrefix}/buses/${id}`)
  return response.data
}

// Operators CRUD
export const getOperators = async (params) => {
  const response = await api.get(`${servicePrefix}/operators`, { params: stripEmptyObjects(params) })
  return response.data
}

export const getOperator = async (id) => {
  const response = await api.get(`${servicePrefix}/operators/${id}`)
  return response.data
}

export const addOperator = async (payload) => {
  const response = await api.post(`${servicePrefix}/operators`, payload)
  return response.data
}

export const updateOperator = async (payload) => {
  const { id, ...body } = payload
  const response = await api.put(`${servicePrefix}/operators/${id}`, body)
  return response.data
}

export const deleteOperator = async (id) => {
  const response = await api.delete(`${servicePrefix}/operators/${id}`)
  return response.data
}

// Routes CRUD
export const getRoutes = async (params) => {
  const response = await api.get(`${servicePrefix}/routes`, { params: stripEmptyObjects(params) })
  return response.data
}

export const getRoute = async (id) => {
  const response = await api.get(`${servicePrefix}/routes/${id}`)
  return response.data
}

export const addRoute = async (payload) => {
  const response = await api.post(`${servicePrefix}/routes`, payload)
  return response.data
}

export const updateRoute = async (payload) => {
  const { id, ...body } = payload
  const response = await api.put(`${servicePrefix}/routes/${id}`, body)
  return response.data
}

export const deleteRoute = async (id) => {
  const response = await api.delete(`${servicePrefix}/routes/${id}`)
  return response.data
}

// Bus Types CRUD
export const getBusTypes = async (params) => api.get(`${servicePrefix}/bus-types`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getBusType = async (id) => api.get(`${servicePrefix}/bus-types/${id}`).then(r => r.data)
export const addBusType = async (payload) => api.post(`${servicePrefix}/bus-types`, payload).then(r => r.data)
export const updateBusType = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/bus-types/${id}`, body).then(r => r.data) }
export const deleteBusType = async (id) => api.delete(`${servicePrefix}/bus-types/${id}`).then(r => r.data)

// Bus Inspections CRUD
export const getBusInspections = async (params) => api.get(`${servicePrefix}/bus-inspections`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getBusInspection = async (id) => api.get(`${servicePrefix}/bus-inspections/${id}`).then(r => r.data)
export const addBusInspection = async (payload) => api.post(`${servicePrefix}/bus-inspections`, payload).then(r => r.data)
export const updateBusInspection = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/bus-inspections/${id}`, body).then(r => r.data) }
export const deleteBusInspection = async (id) => api.delete(`${servicePrefix}/bus-inspections/${id}`).then(r => r.data)

// Bus Inspection Applications CRUD
export const getBusInspectionApplications = async (params) => api.get(`${servicePrefix}/bus-inspection-applications`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getBusInspectionApplication = async (id) => api.get(`${servicePrefix}/bus-inspection-applications/${id}`).then(r => r.data)
export const updateBusInspectionApplication = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/bus-inspection-applications/${id}`, body).then(r => r.data) }
export const deleteBusInspectionApplication = async (id) => api.delete(`${servicePrefix}/bus-inspection-applications/${id}`).then(r => r.data)

// Drivers CRUD
export const getDrivers = async (params) => api.get(`${servicePrefix}/drivers`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getDriver = async (id) => api.get(`${servicePrefix}/drivers/${id}`).then(r => r.data)
export const addDriver = async (payload) => api.post(`${servicePrefix}/drivers`, payload).then(r => r.data)
export const updateDriver = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/drivers/${id}`, body).then(r => r.data) }
export const deleteDriver = async (id) => api.delete(`${servicePrefix}/drivers/${id}`).then(r => r.data)

// Conductors CRUD
export const getConductors = async (params) => api.get(`${servicePrefix}/conductors`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getConductor = async (id) => api.get(`${servicePrefix}/conductors/${id}`).then(r => r.data)
export const addConductor = async (payload) => api.post(`${servicePrefix}/conductors`, payload).then(r => r.data)
export const updateConductor = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/conductors/${id}`, body).then(r => r.data) }
export const deleteConductor = async (id) => api.delete(`${servicePrefix}/conductors/${id}`).then(r => r.data)

// Driver Certifications CRUD
export const getDriverCertifications = async (params) => api.get(`${servicePrefix}/certifications/driver`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getDriverCertification = async (id) => api.get(`${servicePrefix}/certifications/driver/${id}`).then(r => r.data)
export const getDriverCertificationsByCid = async (cid) => api.get(`${servicePrefix}/certifications/driver/by-cid`, { params: { cid } }).then(r => r.data)
export const getDriverCertificationByLicenseNo = async (licenseNo) => api.get(`${servicePrefix}/certifications/driver/by-license`, { params: { licenseNo } }).then(r => r.data)
export const addDriverCertification = async (payload) => api.post(`${servicePrefix}/certifications/driver`, payload).then(r => r.data)
export const updateDriverCertification = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/certifications/driver/${id}`, body).then(r => r.data) }
export const deleteDriverCertification = async (id) => api.delete(`${servicePrefix}/certifications/driver/${id}`).then(r => r.data)
export const uploadDriverCertificationDocument = async (formData) => {
  const response = await api.post(`${servicePrefix}/certifications/driver/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return response.data
}

// Conductor Certifications CRUD
export const getConductorCertifications = async (params) => api.get(`${servicePrefix}/certifications/conductor`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getConductorCertification = async (id) => api.get(`${servicePrefix}/certifications/conductor/${id}`).then(r => r.data)
export const getConductorCertificationsByCid = async (cid) => api.get(`${servicePrefix}/certifications/conductor/by-cid`, { params: { cid } }).then(r => r.data)
export const addConductorCertification = async (payload) => api.post(`${servicePrefix}/certifications/conductor`, payload).then(r => r.data)
export const updateConductorCertification = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/certifications/conductor/${id}`, body).then(r => r.data) }
export const deleteConductorCertification = async (id) => api.delete(`${servicePrefix}/certifications/conductor/${id}`).then(r => r.data)
export const uploadConductorCertificationDocument = async (formData) => {
  const response = await api.post(`${servicePrefix}/certifications/conductor/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return response.data
}

// Route Schedules CRUD
export const getRouteSchedules = async (params) => api.get(`${servicePrefix}/route-schedules`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getRouteSchedule = async (id) => api.get(`${servicePrefix}/route-schedules/${id}`).then(r => r.data)
export const addRouteSchedule = async (payload) => api.post(`${servicePrefix}/route-schedules`, payload).then(r => r.data)
export const updateRouteSchedule = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/route-schedules/${id}`, body).then(r => r.data) }
export const deleteRouteSchedule = async (id) => api.delete(`${servicePrefix}/route-schedules/${id}`).then(r => r.data)

// Places CRUD
export const broadcastToOperators = async (payload) => api.post(`${servicePrefix}/notifications/broadcast`, payload).then(r => r.data)

export const getPlaces = async (params) => api.get(`${servicePrefix}/places`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getPlace = async (id) => api.get(`${servicePrefix}/places/${id}`).then(r => r.data)
export const addPlace = async (payload) => api.post(`${servicePrefix}/places`, payload).then(r => r.data)
export const updatePlace = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/places/${id}`, body).then(r => r.data) }
export const deletePlace = async (id) => api.delete(`${servicePrefix}/places/${id}`).then(r => r.data)

// Road Types CRUD
export const getRoadTypes = async (params) => api.get(`${servicePrefix}/road-types`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getRoadType = async (id) => api.get(`${servicePrefix}/road-types/${id}`).then(r => r.data)
export const addRoadType = async (payload) => api.post(`${servicePrefix}/road-types`, payload).then(r => r.data)
export const updateRoadType = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/road-types/${id}`, body).then(r => r.data) }
export const deleteRoadType = async (id) => api.delete(`${servicePrefix}/road-types/${id}`).then(r => r.data)

// Road Conditions CRUD
export const getRoadConditions = async (params) => api.get(`${servicePrefix}/road-conditions`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getRoadCondition = async (id) => api.get(`${servicePrefix}/road-conditions/${id}`).then(r => r.data)
export const addRoadCondition = async (payload) => api.post(`${servicePrefix}/road-conditions`, payload).then(r => r.data)
export const updateRoadCondition = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/road-conditions/${id}`, body).then(r => r.data) }
export const deleteRoadCondition = async (id) => api.delete(`${servicePrefix}/road-conditions/${id}`).then(r => r.data)

// Drive Types CRUD
export const getDriveTypes = async (params) => api.get(`${servicePrefix}/drive-types`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getDriveType = async (id) => api.get(`${servicePrefix}/drive-types/${id}`).then(r => r.data)
export const addDriveType = async (payload) => api.post(`${servicePrefix}/drive-types`, payload).then(r => r.data)
export const updateDriveType = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/drive-types/${id}`, body).then(r => r.data) }
export const deleteDriveType = async (id) => api.delete(`${servicePrefix}/drive-types/${id}`).then(r => r.data)

// Office Locations CRUD
export const getOfficeLocations = async (params) => api.get(`${servicePrefix}/office-locations`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getRegionalOffices = async (params) => api.get(`${servicePrefix}/office-locations`, { params: stripEmptyObjects({ ...params, isRegional: true }) }).then(r => r.data)
export const getOfficeLocation = async (id) => api.get(`${servicePrefix}/office-locations/${id}`).then(r => r.data)
export const addOfficeLocation = async (payload) => api.post(`${servicePrefix}/office-locations`, payload).then(r => r.data)
export const updateOfficeLocation = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/office-locations/${id}`, body).then(r => r.data) }
export const deleteOfficeLocation = async (id) => api.delete(`${servicePrefix}/office-locations/${id}`).then(r => r.data)

// Dzongkhags CRUD (Passenger Bus)
export const getDzongkhags = async (params) => api.get(`${servicePrefix}/dzongkhags`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getDzongkhag = async (id) => api.get(`${servicePrefix}/dzongkhags/${id}`).then(r => r.data)
export const addDzongkhag = async (payload) => api.post(`${servicePrefix}/dzongkhags`, payload).then(r => r.data)
export const updateDzongkhag = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/dzongkhags/${id}`, body).then(r => r.data) }
export const deleteDzongkhag = async (id) => api.delete(`${servicePrefix}/dzongkhags/${id}`).then(r => r.data)

// Gewogs CRUD (Passenger Bus)
export const getRegions = async (params) => api.get(`${servicePrefix}/regions`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getGewogs = async (params) => api.get(`${servicePrefix}/gewogs`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getGewog = async (id) => api.get(`${servicePrefix}/gewogs/${id}`).then(r => r.data)
export const addGewog = async (payload) => api.post(`${servicePrefix}/gewogs`, payload).then(r => r.data)
export const updateGewog = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/gewogs/${id}`, body).then(r => r.data) }
export const deleteGewog = async (id) => api.delete(`${servicePrefix}/gewogs/${id}`).then(r => r.data)

// Route Proposals CRUD
export const getRouteProposals = async (params) => api.get(`${servicePrefix}/route-proposals`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getRouteProposal = async (id) => api.get(`${servicePrefix}/route-proposals/${id}`).then(r => r.data)
export const addRouteProposal = async (payload) => api.post(`${servicePrefix}/route-proposals`, payload).then(r => r.data)
export const updateRouteProposal = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/route-proposals/${id}`, body).then(r => r.data) }
export const deleteRouteProposal = async (id) => api.delete(`${servicePrefix}/route-proposals/${id}`).then(r => r.data)

// Route Proposal Status Actions
export const submitRouteProposal = async (id) => api.put(`${servicePrefix}/route-proposals/${id}/submit`).then(r => r.data)
export const reviewRouteProposal = async (id, payload) => api.put(`${servicePrefix}/route-proposals/${id}/review`, payload).then(r => r.data)
export const approveRouteProposal = async (id, payload) => api.put(`${servicePrefix}/route-proposals/${id}/approve`, payload).then(r => r.data)
export const rejectRouteProposal = async (id, payload) => api.put(`${servicePrefix}/route-proposals/${id}/reject`, payload).then(r => r.data)

// Route Applications

export const getRouteApplications = async (params) => {
  const response = await api.get(`${servicePrefix}/route-applications`, { params: stripEmptyObjects(params) })
  return response.data
}

export const getRouteApplication = async (id) => {
  const response = await api.get(`${servicePrefix}/route-applications/${id}`)
  return response.data
}

export const updateRouteApplication = async (payload) => {
  const { id, ...body } = payload
  const response = await api.patch(`${servicePrefix}/route-applications/${id}`, body)
  return response.data
}


export const reviewRouteApplication = async (id, payload) => {
  const response = await api.put(`${servicePrefix}/route-applications/${id}/review`, payload)
  return response.data
}

export const approveRouteApplication = async (id, payload) => {
  const response = await api.put(`${servicePrefix}/route-applications/${id}/approve`, payload)
  return response.data
}

export const rejectRouteApplication = async (id, payload) => {
  const response = await api.put(`${servicePrefix}/route-applications/${id}/reject`, payload)
  return response.data
}

// Helper to build FormData for decision endpoints (multipart for file upload)
const buildDecisionFormData = (payload) => {
  const formData = new FormData()
  formData.append('approved', String(payload.approved))
  if (payload.remarks) formData.append('remarks', payload.remarks)
  if (payload.uploadedFile) formData.append('uploadedFile', payload.uploadedFile)
  if (payload.commencementDate) formData.append('commencementDate', payload.commencementDate)
  if (payload.routePermitIssueDate) formData.append('routePermitIssueDate', payload.routePermitIssueDate)
  if (payload.routePermitExpiryDate) formData.append('routePermitExpiryDate', payload.routePermitExpiryDate)
  if (payload.reportingTime) formData.append('reportingTime', payload.reportingTime)
  if (payload.departureTime) formData.append('departureTime', payload.departureTime)
  if (payload.routeCancellationDate) formData.append('routeCancellationDate', payload.routeCancellationDate)
  return formData
}

// Make comprehensive decision on route application (Form 7)
export const makeRouteApplicationDecision = async (id, payload) => {
  const response = await api.put(
    `${servicePrefix}/route-applications/${id}/decision`,
    buildDecisionFormData(payload),
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )
  return response.data
}

// Decision-letter PDF (the server streams it)
export const downloadRouteApplicationDecisionLetter = async (id) => {
  const response = await api.get(`${servicePrefix}/route-applications/${id}/download-decision-letter`, { responseType: 'blob' })
  return response.data
}

// Individual schedule approval
export const approveSchedule = async (applicationId, scheduleId, payload) => {
  const response = await api.put(`${servicePrefix}/route-applications/${applicationId}/schedules/${scheduleId}/approve`, payload)
  return response.data
}

export const rejectSchedule = async (applicationId, scheduleId, payload) => {
  const response = await api.put(`${servicePrefix}/route-applications/${applicationId}/schedules/${scheduleId}/reject`, payload)
  return response.data
}

export const getClaimableRouteApplications = async () => {
  const response = await api.get(`${servicePrefix}/route-applications/claimable`)
  return response.data
}

// Application Claims
export const claimApplication = async (payload) => {
  const response = await api.post(`${servicePrefix}/application-claims`, payload)
  return response.data
}

export const releaseApplicationClaim = async (applicationId, applicationType) => {
  const response = await api.delete(`${servicePrefix}/application-claims/${applicationId}/${applicationType}`)
  return response.data
}

export const getApplicationClaim = async (applicationId, applicationType) => {
  const response = await api.get(`${servicePrefix}/application-claims/${applicationId}/${applicationType}`)
  return response.data
}

export const getUserClaims = async (params) => {
  const response = await api.get(`${servicePrefix}/application-claims/my-claims`, { params: stripEmptyObjects(params) })
  return response.data
}

// Bus Inspection Application Actions
export const approveBusInspectionApplication = async (id, payload) => {
  const response = await api.patch(`${servicePrefix}/bus-inspection-applications/${id}/status`, {
    status: 'approved',
    ...payload
  })
  return response.data
}

export const rejectBusInspectionApplication = async (id, payload) => {
  const response = await api.patch(`${servicePrefix}/bus-inspection-applications/${id}/status`, {
    status: 'rejected',
    ...payload
  })
  return response.data
}

export const scheduleBusInspection = async (id, payload) => {
  const response = await api.patch(`${servicePrefix}/bus-inspection-applications/${id}/schedule-inspection`, payload)
  return response.data
}

// Inspection Checklist Sections CRUD (adding missing functions)
export const getInspectionChecklistSections = async (params) => api.get(`${servicePrefix}/inspection-checklist-sections`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getInspectionChecklistSection = async (id) => api.get(`${servicePrefix}/inspection-checklist-sections/${id}`).then(r => r.data)
export const addInspectionChecklistSection = async (payload) => api.post(`${servicePrefix}/inspection-checklist-sections`, payload).then(r => r.data)
export const updateInspectionChecklistSection = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/inspection-checklist-sections/${id}`, body).then(r => r.data) }
export const deleteInspectionChecklistSection = async (id) => api.delete(`${servicePrefix}/inspection-checklist-sections/${id}`).then(r => r.data)

// Inspection Checklist Items CRUD
export const getInspectionChecklistItems = async (params) => api.get(`${servicePrefix}/inspection-checklist-items`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getInspectionChecklistItem = async (id) => api.get(`${servicePrefix}/inspection-checklist-items/${id}`).then(r => r.data)
export const getInspectionChecklistItemsBySection = async (sectionId) => api.get(`${servicePrefix}/inspection-checklist-sections/${sectionId}/items`).then(r => r.data)
export const addInspectionChecklistItem = async (payload) => api.post(`${servicePrefix}/inspection-checklist-items`, payload).then(r => r.data)
export const updateInspectionChecklistItem = async (payload) => { const { id, ...body } = payload; return api.put(`${servicePrefix}/inspection-checklist-items/${id}`, body).then(r => r.data) }
export const deleteInspectionChecklistItem = async (id) => api.delete(`${servicePrefix}/inspection-checklist-items/${id}`).then(r => r.data)

// Bus Inspection Reports (Staging) CRUD
export const saveInspectionStage = async (payload) => {
  const response = await api.post(`${servicePrefix}/bus-inspection-reports/save-stage`, payload)
  return response.data
}

export const getInspectionReport = async (id) => {
  const response = await api.get(`${servicePrefix}/bus-inspection-reports/${id}`)
  return response.data
}

export const getInspectionReportByApplication = async (applicationId) => {
  const response = await api.get(`${servicePrefix}/bus-inspection-reports/by-application/${applicationId}`)
  return response.data
}

export const finalizeInspectionReport = async (id, payload) => {
  const response = await api.post(`${servicePrefix}/bus-inspection-reports/${id}/finalize`, payload)
  return response.data
}

export const uploadInspectionAttachment = async (reportId, formData) => {
  const response = await api.post(`${servicePrefix}/bus-inspection-reports/${reportId}/attachments`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data
}

export const uploadInspectionSectionAttachment = async (reportId, sectionResultId, formData) => {
  const response = await api.post(`${servicePrefix}/bus-inspection-reports/${reportId}/sections/${sectionResultId}/attachments`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data
}

// Route Applications (adding missing CRUD functions)
export const deleteRouteApplication = async (id) => api.delete(`${servicePrefix}/route-applications/${id}`).then(r => r.data)

// Claimable Applications (alias for consistency)
export const getClaimableApplications = async () => getClaimableRouteApplications()

// Operator Authentication Functions
export const operatorRegister = async (payload) => {
  const response = await api.post(`${servicePrefix}/operators/register`, payload)
  return response.data
}

export const operatorLogin = async (payload) => {
  const response = await api.post(`${servicePrefix}/operators/login`, payload)
  return response.data
}

export const getPendingOperators = async (params) => {
  const response = await api.get(`${servicePrefix}/operators/pending`, { params: stripEmptyObjects(params) })
  return response.data
}

export const approveOperator = async (id, payload) => {
  const response = await api.patch(`${servicePrefix}/operators/${id}/approval`, payload)
  return response.data
}

// Staff: a new one-time password, returned once ({ temporaryPassword })
export const resetOperatorPassword = async (id) => api.post(`${servicePrefix}/operators/${id}/reset-password`).then(r => r.data)

// Operator: set their own password (required after a temporary one)
export const changeOwnOperatorPassword = async (payload) => api.patch(`${servicePrefix}/operators/me/password`, payload)

// ERALIS Data Integration
export const getEralisData = async (cid, dataType) => {
  if (dataType === 'personal') {
    try {
      // First search by CID to get the basic info
      const searchResponse = await PersonalInformationService.searchPersonalInfo(cid)
      
      if (searchResponse && searchResponse.id) {
        // Then get full individual details using the ID
        const individualDetails = await PersonalInformationService.getPisIndividual(searchResponse.id)
        return {
          personalInfo: individualDetails
        }
      } else {
        throw new Error('No personal information found for this CID')
      }
    } catch (error) {
      console.error('Error fetching personal information:', error)
      throw error
    }
  } else if (dataType === 'business') {
    // This is a placeholder for business license API integration
    // You'll need to implement the actual business license API call here
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          businessLicense: {
            licenseNumber: 'BL-2023-001',
            businessName: 'Tshewang Transport Services',
            issueDate: '2023-01-15',
            expiryDate: '2025-01-14',
            status: 'Active',
            businessType: 'Transportation Services',
            address: 'Thimphu, Bhutan'
          }
        })
      }, 1000)
    })
  }
}

// ==========================================
// Route Permits
// ==========================================
export const getRoutePermits = async (params) => api.get(`${servicePrefix}/route-permits`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getRoutePermit = async (id) => api.get(`${servicePrefix}/route-permits/${id}`).then(r => r.data)
export const updateRoutePermit = async (payload) => { const { id, ...body } = payload; return api.patch(`${servicePrefix}/route-permits/${id}`, body).then(r => r.data) }
export const deleteRoutePermit = async (id) => api.delete(`${servicePrefix}/route-permits/${id}`).then(r => r.data)
export const submitRoutePermit = async (id) => api.put(`${servicePrefix}/route-permits/${id}/submit`).then(r => r.data)
export const reviewRoutePermit = async (id, payload) => api.put(`${servicePrefix}/route-permits/${id}/review`, payload).then(r => r.data)
export const makeRoutePermitDecision = async (id, payload) => api.put(`${servicePrefix}/route-permits/${id}/decision`, buildDecisionFormData(payload), { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data)
export const getClaimableRoutePermits = async () => api.get(`${servicePrefix}/route-permits/claimable`).then(r => r.data)

// ==========================================
// Route Suspensions
// ==========================================
export const getRouteSuspensions = async (params) => api.get(`${servicePrefix}/route-suspensions`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getRouteSuspension = async (id) => api.get(`${servicePrefix}/route-suspensions/${id}`).then(r => r.data)
export const addRouteSuspension = async (payload) => api.post(`${servicePrefix}/route-suspensions`, payload).then(r => r.data)
export const updateRouteSuspension = async (payload) => { const { id, ...body } = payload; return api.patch(`${servicePrefix}/route-suspensions/${id}`, body).then(r => r.data) }
export const deleteRouteSuspension = async (id) => api.delete(`${servicePrefix}/route-suspensions/${id}`).then(r => r.data)
export const submitRouteSuspension = async (id) => api.put(`${servicePrefix}/route-suspensions/${id}/submit`).then(r => r.data)
export const reviewRouteSuspension = async (id, payload) => api.put(`${servicePrefix}/route-suspensions/${id}/review`, payload).then(r => r.data)
export const makeRouteSuspensionDecision = async (id, payload) => api.put(`${servicePrefix}/route-suspensions/${id}/decision`, buildDecisionFormData(payload), { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data)
export const reinstateRouteSuspension = async (id, { reinstatementRemarks, workshopReportFile }) => {
  const formData = new FormData()
  if (reinstatementRemarks) formData.append('reinstatementRemarks', reinstatementRemarks)
  if (workshopReportFile) formData.append('workshopReportFile', workshopReportFile)
  return api.put(`${servicePrefix}/route-suspensions/${id}/reinstate`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data)
}
export const getClaimableRouteSuspensions = async () => api.get(`${servicePrefix}/route-suspensions/claimable`).then(r => r.data)

// ==========================================
// Route Cancellations
// ==========================================
export const getRouteCancellations = async (params) => api.get(`${servicePrefix}/route-cancellations`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getRouteCancellation = async (id) => api.get(`${servicePrefix}/route-cancellations/${id}`).then(r => r.data)
export const addRouteCancellation = async (payload) => api.post(`${servicePrefix}/route-cancellations`, payload).then(r => r.data)
export const updateRouteCancellation = async (payload) => { const { id, ...body } = payload; return api.patch(`${servicePrefix}/route-cancellations/${id}`, body).then(r => r.data) }
export const deleteRouteCancellation = async (id) => api.delete(`${servicePrefix}/route-cancellations/${id}`).then(r => r.data)
export const submitRouteCancellation = async (id) => api.put(`${servicePrefix}/route-cancellations/${id}/submit`).then(r => r.data)
export const reviewRouteCancellation = async (id, payload) => api.put(`${servicePrefix}/route-cancellations/${id}/review`, payload).then(r => r.data)
export const makeRouteCancellationDecision = async (id, payload) => api.put(`${servicePrefix}/route-cancellations/${id}/decision`, buildDecisionFormData(payload), { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data)
export const getClaimableRouteCancellations = async () => api.get(`${servicePrefix}/route-cancellations/claimable`).then(r => r.data)
export const checkOperatorBarred = async (operatorId) => api.get(`${servicePrefix}/route-cancellations/check-barred/${operatorId}`).then(r => r.data)

// ==========================================
// Fleet Updates
// ==========================================
export const getFleetUpdates = async (params) => api.get(`${servicePrefix}/fleets`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getFleetUpdate = async (id) => api.get(`${servicePrefix}/fleets/${id}`).then(r => r.data)
export const addFleetUpdate = async (payload) => api.post(`${servicePrefix}/fleets`, payload).then(r => r.data)
export const updateFleetUpdate = async (payload) => { const { id, ...body } = payload; return api.patch(`${servicePrefix}/fleets/${id}`, body).then(r => r.data) }
export const deleteFleetUpdate = async (id) => api.delete(`${servicePrefix}/fleets/${id}`).then(r => r.data)
export const getScheduledFleets = async (params) => api.get(`${servicePrefix}/fleets/scheduled`, { params: stripEmptyObjects(params) }).then(r => r.data)
// The API wants HH:mm (24h); a blank time means now.
const fleetTime = (time) => time || new Date().toTimeString().slice(0, 5)
export const markFleetDeparted = async (id, { time } = {}) => api.put(`${servicePrefix}/fleets/${id}/depart`, { actualDepartureTime: fleetTime(time) }).then(r => r.data)
export const markFleetArrived = async (id, { time, remarks } = {}) => api.put(`${servicePrefix}/fleets/${id}/arrive`, { actualArrivalTime: fleetTime(time), arrivalRemarks: remarks || undefined }).then(r => r.data)

// Legacy Routes
export const getLegacyRoutes = async (params) => api.get(`${servicePrefix}/legacy-routes`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getLegacyRoute = async (id) => api.get(`${servicePrefix}/legacy-routes/${id}`).then(r => r.data)
export const addLegacyRoute = async (payload) => api.post(`${servicePrefix}/legacy-routes`, payload).then(r => r.data)
export const updateLegacyRoute = async (payload) => { const { id, ...body } = payload; return api.patch(`${servicePrefix}/legacy-routes/${id}`, body).then(r => r.data) }
export const deleteLegacyRoute = async (id) => api.delete(`${servicePrefix}/legacy-routes/${id}`).then(r => r.data)
export const getLegacyRouteSchedules = async (id) => api.get(`${servicePrefix}/legacy-routes/${id}/schedules`).then(r => r.data)
export const addLegacyRouteSchedule = async (routeId, payload) => api.post(`${servicePrefix}/legacy-routes/${routeId}/schedules`, payload).then(r => r.data)
export const deleteLegacyRouteSchedule = async (routeId, scheduleId) => api.delete(`${servicePrefix}/legacy-routes/${routeId}/schedules/${scheduleId}`).then(r => r.data)
export const uploadLegacyRoutes = async (file) => { const formData = new FormData(); formData.append('file', file); return api.post(`${servicePrefix}/legacy-routes/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data) }
export const confirmLegacyRoutesUpload = async (payload) => api.post(`${servicePrefix}/legacy-routes/upload/confirm`, payload).then(r => r.data)

// Schedule Availability
export const checkScheduleAvailability = async (payload) => api.post(`${servicePrefix}/schedule-availability/check`, payload).then(r => r.data)
export const getScheduleOccupancy = async (params) => api.get(`${servicePrefix}/schedule-availability/occupancy`, { params: stripEmptyObjects(params) }).then(r => r.data)
export const getAvailableSlots = async (params) => api.get(`${servicePrefix}/schedule-availability/available`, { params: stripEmptyObjects(params) }).then(r => r.data)

export default {
  resetOperatorPassword,
  changeOwnOperatorPassword,
  getBuses,
  getBus,
  addBus,
  updateBus,
  deleteBus,
  getOperators,
  getOperator,
  addOperator,
  updateOperator,
  deleteOperator,
  getBusTypes,
  getBusType,
  addBusType,
  updateBusType,
  deleteBusType,
  getBusInspections,
  getBusInspection,
  addBusInspection,
  updateBusInspection,
  deleteBusInspection,
  getBusInspectionApplications,
  getBusInspectionApplication,
  updateBusInspectionApplication,
  deleteBusInspectionApplication,
  getRoadTypes,
  getRoadType,
  addRoadType,
  updateRoadType,
  deleteRoadType,
  getRoadConditions,
  getRoadCondition,
  addRoadCondition,
  updateRoadCondition,
  deleteRoadCondition,
  getOfficeLocations,
  getRegionalOffices,
  getOfficeLocation,
  addOfficeLocation,
  updateOfficeLocation,
  deleteOfficeLocation,
  getPlaces,
  broadcastToOperators,
  getPlace,
  addPlace,
  updatePlace,
  deletePlace,
  getRoutes,
  getRoute,
  addRoute,
  updateRoute,
  deleteRoute,
  getRouteSchedules,
  getRouteSchedule,
  addRouteSchedule,
  updateRouteSchedule,
  deleteRouteSchedule,
  getDriveTypes,
  getDriveType,
  addDriveType,
  updateDriveType,
  deleteDriveType,
  getDrivers,
  getDriver,
  addDriver,
  updateDriver,
  deleteDriver,
  getConductors,
  getConductor,
  addConductor,
  updateConductor,
  deleteConductor,
  // Driver Certifications
  getDriverCertifications,
  getDriverCertification,
  getDriverCertificationsByCid,
  getDriverCertificationByLicenseNo,
  addDriverCertification,
  updateDriverCertification,
  deleteDriverCertification,
  uploadDriverCertificationDocument,
  // Conductor Certifications
  getConductorCertifications,
  getConductorCertification,
  getConductorCertificationsByCid,
  addConductorCertification,
  updateConductorCertification,
  deleteConductorCertification,
  uploadConductorCertificationDocument,
  getInspectionChecklistSections,
  getInspectionChecklistSection,
  addInspectionChecklistSection,
  updateInspectionChecklistSection,
  deleteInspectionChecklistSection,
  getInspectionChecklistItems,
  getInspectionChecklistItem,
  getInspectionChecklistItemsBySection,
  addInspectionChecklistItem,
  updateInspectionChecklistItem,
  deleteInspectionChecklistItem,
  // Bus Inspection Reports (Staging)
  saveInspectionStage,
  getInspectionReport,
  getInspectionReportByApplication,
  finalizeInspectionReport,
  uploadInspectionAttachment,
  uploadInspectionSectionAttachment,
  // Bus Inspection Application Actions
  approveBusInspectionApplication,
  rejectBusInspectionApplication,
  scheduleBusInspection,
  getRouteApplications,
  getRouteApplication,
  updateRouteApplication,
  deleteRouteApplication,
  reviewRouteApplication,
  approveRouteApplication,
  rejectRouteApplication,
  makeRouteApplicationDecision,
  approveSchedule,
  rejectSchedule,
  getClaimableApplications,
  claimApplication,
  releaseApplicationClaim,
  getApplicationClaim,
  getUserClaims,
  // Operator Authentication
  operatorRegister,
  operatorLogin,
  getPendingOperators,
  approveOperator,
  getEralisData,
  // Route Permits
  getRoutePermits,
  getRoutePermit,
  updateRoutePermit,
  deleteRoutePermit,
  submitRoutePermit,
  reviewRoutePermit,
  makeRoutePermitDecision,
  getClaimableRoutePermits,
  // Route Suspensions
  getRouteSuspensions,
  getRouteSuspension,
  addRouteSuspension,
  updateRouteSuspension,
  deleteRouteSuspension,
  submitRouteSuspension,
  reviewRouteSuspension,
  makeRouteSuspensionDecision,
  reinstateRouteSuspension,
  getClaimableRouteSuspensions,
  // Route Cancellations
  getRouteCancellations,
  getRouteCancellation,
  addRouteCancellation,
  updateRouteCancellation,
  deleteRouteCancellation,
  submitRouteCancellation,
  reviewRouteCancellation,
  makeRouteCancellationDecision,
  getClaimableRouteCancellations,
  checkOperatorBarred,
  // Fleet Updates
  getFleetUpdates,
  getFleetUpdate,
  addFleetUpdate,
  updateFleetUpdate,
  deleteFleetUpdate,
  getScheduledFleets,
  markFleetDeparted,
  markFleetArrived,
  // Dzongkhags
  getDzongkhags,
  getDzongkhag,
  addDzongkhag,
  updateDzongkhag,
  deleteDzongkhag,
  // Gewogs
  getGewogs,
  getGewog,
  addGewog,
  updateGewog,
  deleteGewog,
  // Regions
  getRegions,
  // Legacy Routes
  getLegacyRoutes,
  getLegacyRoute,
  addLegacyRoute,
  updateLegacyRoute,
  deleteLegacyRoute,
  getLegacyRouteSchedules,
  addLegacyRouteSchedule,
  deleteLegacyRouteSchedule,
  uploadLegacyRoutes,
  confirmLegacyRoutesUpload,
  // Schedule Availability
  checkScheduleAvailability,
  getScheduleOccupancy,
  getAvailableSlots
}
